import { motion } from "framer-motion";
import { Eyebrow } from "@/components/Eyebrow";
import { Reveal } from "@/components/Reveal";

const VERBOS = [
  "Preguntando.",
  "Dudando.",
  "Comparando.",
  "Confiando.",
  "Cambiando de opinión.",
  "Volviendo.",
];

export default function About() {
  return (
    <section
      data-testid="about-section"
      className="px-6 py-28 md:px-12 md:py-40 lg:px-20"
    >
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-16 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Eyebrow index="04" label="La persona" />
          <Reveal delay={0.1}>
            <h2 className="mt-10 font-serif text-4xl leading-[1.12] sm:text-5xl">
              Mi experiencia explica mi mirada.
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-8 max-w-xl font-serif text-2xl italic leading-snug text-mirian-wine/80 sm:text-3xl">
              No aprendí a mirar al cliente en una pantalla.
            </p>
          </Reveal>
          <Reveal delay={0.22}>
            <div className="mt-10 max-w-xl space-y-5 text-base leading-relaxed text-mirian-wine/75">
              <p>
                Soy brasileña, vivo en España y estoy terminando el Máster en
                Dirección de Marketing y Gestión Comercial (GESCO) en ESIC.
              </p>
              <p>
                Antes de llegar hasta aquí, mi trayectoria pasó por lugares
                bastante diferentes: marketing, ventas, retail, ecommerce,
                gestión de equipos, atención directa al cliente y creación de
                contenido.
              </p>
              <p>
                Y durante mucho tiempo hubo algo en común: personas reales
                tomando decisiones reales delante de mí.
              </p>
            </div>
          </Reveal>

          <ul
            data-testid="about-verbos"
            className="mt-12 space-y-2 font-serif text-2xl italic text-mirian-wine/85 sm:text-3xl"
          >
            {VERBOS.map((verbo, i) => (
              <motion.li
                key={verbo}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10% 0px" }}
                transition={{ duration: 0.7, delay: i * 0.16, ease: [0.22, 1, 0.36, 1] }}
                style={{ paddingLeft: `${i * 1.25}rem` }}
              >
                {verbo}
              </motion.li>
            ))}
          </ul>

          <Reveal delay={0.15}>
            <div className="mt-12 max-w-xl space-y-5 text-base leading-relaxed text-mirian-wine/75">
              <p>
                Mucho antes de hablar de customer journey, ya estaba viendo uno
                ocurrir delante de mí.
              </p>
              <p>Hoy intento llevar esa misma curiosidad al marketing.</p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.35} className="lg:col-span-5">
          <figure
            data-testid="about-photo"
            className="relative aspect-[3/4] overflow-hidden bg-mirian-wine lg:sticky lg:top-24"
          >
            <img
              src="/mirian-barcos.jpg"
              alt="Retrato de Mírian Barcos"
              loading="lazy"
              className="h-full w-full object-cover"
            />
            <div
              aria-hidden="true"
              className="absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-mirian-wine/70 to-transparent"
            />
            <figcaption className="absolute inset-x-0 bottom-0 p-6 text-xs uppercase tracking-[0.2em] text-mirian-cream/85">
              Mírian Barcos
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </section>
  );
}
